var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtomsIconFilledMusclesButtercup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "vku4fop8aa",
    d: "M0 0L41.943 0 41.943 42.964 0 42.964z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1127 -656) translate(889 472) translate(238 184)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g9y9m5fevb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vku4fop8aa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F6A11D",
    d: "M40.939 38.425c-.072-.72-.023-1.453-.029-2.18-.03-3.869-.057-7.737-.102-11.605-.003-.306.22-.878-.5-.696-1.778.448-3.115-.32-4.399-1.424-3.194-2.75-6.949-3.847-11.134-3.384-3.717.41-6.844 2.21-9.799 4.342-.657.474-1.286.987-1.927 1.482l-.16-.108c.103-.412.205-.825.31-1.236.631-2.456.482-4.967.546-7.463.037-1.429.182-2.838.906-4.135.362-.648.783-.93 1.565-.747 1.406.33 2.84.506 4.293.398 1.622-.122 2.371-.795 2.593-2.393.043-.307.187-.395.426-.449 1.623-.363 2.287-2.38 1.455-3.927-.663-1.232-1.365-2.446-2.09-3.644C22.307.287 21.4-.11 20.266.026c-.496.06-.994.135-1.477.255-4.055 1.007-7.263 3.35-9.785 6.519-2.798 3.513-4.493 7.645-5.834 11.872-1.29 4.062-1.81 8.292-2.098 12.531-.205 3.026 1.006 4.812 3.832 6.005 1.36.574 2.784.938 4.243 1.166 3.79.592 11.156 2.444 14.977 2.56 6.447.196 9.362-1.501 15.814-1.53.752-.003 1.08-.182 1-.979",
    mask: "url(#g9y9m5fevb)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomsIconFilledMusclesButtercup);
export default __webpack_public_path__ + "static/media/atoms-icon-filled-muscles--buttercup.5d47f96eee22d006727f3a96f03a611c.svg";
export { ForwardRef as ReactComponent };